<template>
  <div>
    <b-card
      ref="weatherCard"
      class="bg-info"
    >
    <b-card-title class="subT text-center mb-0"> 
       <b >지역날씨</b>
    </b-card-title>
    <b-card-body>
      <load-page v-if="!show"></load-page>
      <div
      v-show="show"
      style="margin: 0 auto;text-align:center;display:table;">
        <b-img
          :src="icon"
          alt="weather logo"/>
        <p class="subT"> {{ location }} {{ weather }}</p>
        <p class="subT"> 현재온도 : {{ temp }} ℃ </p>
        <p class="subT"> 현재습도 : {{ humidity }} ％ </p>
        <p class="subT"> 풍속 : {{ wind_speed }} ㎧ </p>
        <p class="subT"> 가축더위지수 : {{ getAlertStep(stressPoint) }} </p>
      </div>  
    </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from '@/store'
import {
  BCardText, 
  BRow, BCol, 
  BMedia, 
  BMediaAside, 
  BMediaBody, 
  BImg, BCard,
  BCardBody,
  BCardTitle,
  BCardFooter,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import axios from '@axios'
import LoadPage from '@/views/pages/utils/LoadPage.vue'
export default {
  components: {
    BCardFooter,
    BCardBody,
    BCardTitle,
    BCard,
    BRow,
    BCol,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    LoadPage
  },
  props: {
    loca: {
      latitude: {
        type: String,
        required: true
      },
      longitude: {
        type: String,
        required: true
      }
    }
  },
  data() {
    return {
      location: '',
      weather: '',
      icon: '',
      temp: '',
      temp_min: '',
      temp_max: '',
      pressure: '',
      humidity: '',
      wind_speed: '',
      wind_deg: '',
      stressPoint: 0,
      show: false
    }
  },
  computed: {
    statisticsItems() {
      return [
        {
          icon: 'ThermometerIcon',
          color: 'light-primary',
          title: '온도',
          subtitle: `${this.temp} ℃`,
        },
        {
          icon: 'DropletIcon',
          color: 'light-info',
          title: '습도',
          subtitle: `${this.humidity} ％`,
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-danger',
          title: '최고 온도',
          subtitle: `${this.temp_max} °C`,
        },
        {
          icon: 'TrendingDownIcon',
          color: 'light-danger',
          title: '최저 온도',
          subtitle: `${this.temp_min} °C`,
        },
        {
          icon: 'WindIcon',
          color: 'light-success',
          title: '풍속',
          subtitle: `${this.wind_speed} km/h`,
        },
        {
          icon: 'DownloadCloudIcon',
          color: 'light-success',
          title: '기압',
          subtitle: `${this.pressure} hpa`,
        },
      ]
    },
  },
  created() {
    //this.getWeatherData()
    
  },
  methods: {
    getCurrentTime() {
      return new Date().toLocaleString()
    },
    async getWeatherData(loca) {
      let parmas
      try {
        
        if(loca) {
          parmas = {
            lat: loca.latitude,
            lon: loca.longitude
          }
        } else {
          let userInfo = await store.dispatch('users/fetchUser', { id: getUserData().id})
          let user = {
            lat: userInfo.data.lat,
            lon: userInfo.data.lon
          }
          parmas = {
            lat: (user !== null) ? user.lat : '37.558131',
            lon: (user !== null) ? user.lon : '126.945476',
          }
        }
        const result = await axios.get('/utils/weather', { params: parmas })
        this.location = result.data.location.toUpperCase()
        this.temp = result.data.temp.toFixed(1)
        this.pressure = result.data.pressure
        this.temp_max = result.data.temp_max.toFixed(2)
        this.temp_min = result.data.temp_min.toFixed(2)
        this.humidity = result.data.humidity
        this.weather = result.data.weather
        this.wind_deg = result.data.wind_deg
        this.wind_speed = result.data.wind_speed
        this.icon = result.data.icon
        this.$refs.weatherCard.showLoading = false
        this.show = true
        this.stressPoint = this.getHeatStressIndex(this.temp, this.humidity)
        return {
          temperature: this.temp,
          humidity: this.humidity = result.data.humidity,
          wind_speed: this.wind_speed
        }
      } catch (err) {
        alert('위치를 불러올 수 없습니다')
        //console.log(err)
        //this.getWeatherData()
      }

    },
    getAlertStep (stressPoint) {
      if(isNaN(stressPoint)) return "측정 불가" 
      else if(stressPoint <= 72) return '정상' 
      else if (stressPoint <= 78) return "주의" 
      else if (stressPoint <= 89) return "경고"
      else if (stressPoint <= 98) return "위험"
      else return "심각"
    },
    getHeatStressIndex(temperature, humidity) {
      return parseInt((1.8 * temperature + 32) - ((0.55 - 0.0055 * humidity) * (1.8 * temperature - 26.8)))
    },
  },
}
</script>
<style scoped>
b {
  text-align: center;
}
.subT {
  color: white;
  font-size: large;
  font-weight: 600;
}
.cus_mt {
  margin-top: 0.5rem;
}
</style>

